module.exports = "/packs/images/homepage/facilities/spa_mobile~884c78b0c1e63fbc492f9fcef99a08b5.jpg";